import Swiper, {EffectFade, HashNavigation, Navigation} from 'swiper';
import TenderComponent from './TenderComponent.vue';
import Vue from 'vue';

const tenderMonths = Array.from(document.querySelectorAll('.j-tender__month'));
const tenderMonthActive = document.querySelector('.j-tender__month.is-active');
const tenderSlider = document.querySelector('.j-tender-slider');
const tenderMoreBtns = Array.from(document.querySelectorAll('.j-tender__more'));
const tenderContacts = Array.from(document.querySelectorAll('.j-tender__contact'));
const tenderDropdown = document.querySelector('.j-tendet__droprodown');

let swiper = {};

Vue.component(TenderComponent.name, TenderComponent);

document.querySelectorAll('.tender-app').forEach((el) => {
    new Vue({el}); // eslint-disable-line no-new
});

const sliderHowToGetAccerideted = Array.from(document.querySelectorAll('.j-how-get-accredited'));

sliderHowToGetAccerideted.forEach((item) => {
    const sliderContent = item.querySelector('.j-career-slider');
    const options = {
        enabled      : true,
        modules      : [Navigation],
        loop         : false,
        speed        : 800,
        spaceBetween : 0,
        slidesPerView: 'auto',
        navigation   : {
            nextEl: item.querySelector('.j-career-next'),
            prevEl: item.querySelector('.j-career-prev')
        },
        breakpoints: {
            1280: {
                enabled: false
            }
        }
    };

    new Swiper(sliderContent, options); // eslint-disable-line no-new
});


// TODO Delete later

if (tenderSlider) {
    const tenderOptions = {
        modules          : [EffectFade, HashNavigation],
        autoHeight       : true,
        init             : false,
        loop             : false,
        speed            : 1000,
        spaceBetween     : 0,
        slidesPerView    : 1,
        slidesOffsetAfter: 0,
        allowTouchMove   : false,
        effect           : 'fade',
        fadeEffect       : {
            crossFade: true
        }
    };

    swiper = new Swiper(tenderSlider, tenderOptions).init();
    if (tenderMonthActive) {
        swiper.slideTo(tenderMonthActive.dataset.slide - 1);
    }
}

tenderMonths.forEach((button) => {
    button.addEventListener('click', () => {
        if (button.classList.contains('is-active')) {
            return;
        }

        const nowActive = tenderMonths.find((item) => {
            return item.classList.contains('is-active');
        });

        if (swiper.initialized) {
            swiper.slideTo(button.dataset.slide - 1);
        }

        if (nowActive) {
            nowActive.classList.remove('is-active');
        }

        button.classList.add('is-active');
    });
});


tenderMoreBtns.forEach((button) => {
    button.addEventListener('click', () => {
        button.closest('.j-tender__slide').classList.add('is-full');
        button.classList.add('is-hide');

        swiper.updateAutoHeight(200);
    });
});

if (tenderDropdown) {
    const button = tenderDropdown.querySelector('.j-tendet__droprodown-head');

    if (button) {
        button.addEventListener('click', () => {
            tenderDropdown.classList.toggle('active');
        });
    }
}

tenderContacts.forEach((contact) => {
    contact.addEventListener('click', () => {
        contact.classList.toggle('active');
    });
});
